/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_EditInputs */

const en_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const es_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fr_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const nl_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

const it_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const pt_br2_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const pl_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

const hu_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szerkesztés`)
};

const ro_admin_dashboard_edit = /** @type {(inputs: Admin_Dashboard_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editati`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Admin_Dashboard_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_edit = /** @type {((inputs?: Admin_Dashboard_EditInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_EditInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_edit(inputs)
	if (locale === "de") return de_admin_dashboard_edit(inputs)
	if (locale === "es") return es_admin_dashboard_edit(inputs)
	if (locale === "fr") return fr_admin_dashboard_edit(inputs)
	if (locale === "nl") return nl_admin_dashboard_edit(inputs)
	if (locale === "it") return it_admin_dashboard_edit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_edit(inputs)
	if (locale === "pl") return pl_admin_dashboard_edit(inputs)
	if (locale === "hu") return hu_admin_dashboard_edit(inputs)
	return ro_admin_dashboard_edit(inputs)
});
export { admin_dashboard_edit as "admin.dashboard.edit" }